import { put, call } from "redux-saga/effects";
import { readingPlanConstants } from "../actions/constants/readingPlanConstants";
import { ReadingPlanService } from "../services/api/readingPlanService";
import { exceptionHandler, getStatus } from "../pages/common/functions";

function* readingPlanSave(request: any) {
	try {
		const result = yield call(ReadingPlanService.readingPlanSave, request.input);		
		const res = exceptionHandler(result)
		if (res.status) {
			yield put({
				type: readingPlanConstants.ReadingPlanSaveSuccess,
				payload: res.data
			});
		}
		else {
			yield put({ type: readingPlanConstants.ReadingPlanSaveFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: readingPlanConstants.ReadingPlanSaveFailure, payload: error });
	}
}

function* readingPlanGetDetail(request: any) {
	try {
		const result = yield call(ReadingPlanService.readingPlanGetDetail, request.input);
		const res = exceptionHandler(result)
		if (res.status) {
			yield put({
				type: readingPlanConstants.ReadingPlanDetailSuccess,
				payload: res.data,
			});
		}
		else {
			yield put({ type: readingPlanConstants.ReadingPlanDetailFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: readingPlanConstants.ReadingPlanDetailFailure, payload: error });
	}
}

function* readingPlanGetByFilter(request: any) {
	try {
		const result = yield call(ReadingPlanService.readingPlanGetByFilter, request.input);
		const res = exceptionHandler(result)
		if (res.status) {
			yield put({
				type: readingPlanConstants.ReadingPlanGetByFilterSucccess,
				payload: res.data,
			});
		}
		else {
			yield put({ type: readingPlanConstants.ReadingPlanGetByFilterFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: readingPlanConstants.ReadingPlanGetByFilterFailure, payload: error });
	}
}

function* readingPlanDelete(request: any) {
	try {
		const result = yield call(ReadingPlanService.readingPlanDelete, request.input);
		const res = exceptionHandler(result)
		if (res.status) {
			yield put({
				type: readingPlanConstants.ReadingPlanDeleteSuccess,
				payload: res.data,
			});
		}
		else {
			yield put({ type: readingPlanConstants.ReadingPlanDeleteFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: readingPlanConstants.ReadingPlanDeleteFailure, payload: error });
	}
}

function* readingPlanDaySave(request: any) {
	try {
		const result = yield call(ReadingPlanService.readingPlanDaySave, request.input);
		const res = exceptionHandler(result)
		if (res.status)
		{
			yield put({
				type: readingPlanConstants.ReadingPlanDaySaveSuccess,
				payload: res.data,
			});
		}
		else
		{
			yield put({ type: readingPlanConstants.ReadingPlanDaySaveFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: readingPlanConstants.ReadingPlanDaySaveFailure, payload: error });
	}
}


function* readingPlanCopy(request: any) {
	try {
		const result = yield call(ReadingPlanService.readingPlanCopy, request.input);
		const res = exceptionHandler(result)
		if (res.status) {
			yield put({
				type: readingPlanConstants.ReadingPlanCopySuccess,
				payload: res.data,
			});
		}
		else {
			yield put({ type: readingPlanConstants.ReadingPlanCopyFailure, payload: res.data});
		}
	} catch (error) {
		yield put({ type: readingPlanConstants.ReadingPlanCopyFailure, payload: error });
	}
}

function* readingPlanDayDelete(request: any) {
	try {
		const result = yield call(ReadingPlanService.readingPlanDayDelete, request.input);
		const res = exceptionHandler(result)
		if (res.status) {
			yield put({
				type: readingPlanConstants.ReadingPlanDayDeleteSuccess,
				payload: res.data
			});
		}
		else {
			yield put({ type: readingPlanConstants.ReadingPlanDayDeleteFailure, payload: res.data });
		}
	} catch (error: any) {
		yield put({ type: readingPlanConstants.ReadingPlanDayDeleteFailure, payload: error });
	}
}

export const readingPlanSaga = {
	readingPlanSave,
	readingPlanGetDetail,
	readingPlanGetByFilter,
	readingPlanDelete,
	readingPlanDaySave,
	readingPlanCopy,
	readingPlanDayDelete
}